import { autosave, autosaveKeepalive } from './autosave';
import { getFormSubmissionUuid } from './getFormSubmissionUuid';
import { getIcdCodes } from './getIcdCodes';
import { getSchema } from './getSchema';
import { getUploadFilesizeLimit } from './getUploadFilesizeLimit';
import { submitAddendumNote } from './submitAddendumNote';
import { submitIcdCodes } from './submitIcdCodes';
import { submitReform } from './submitReform';
import { submitReformSupervisor } from './submitReformSupervisor';
import { submitScreening } from './submitScreening';

const DocumentService = {
  autosave,
  autosaveKeepalive,
  getSchema,
  submitReform,
  submitReformSupervisor,
  getIcdCodes,
  submitIcdCodes,
  submitAddendumNote,
  submitScreening,
  getUploadFilesizeLimit,
  getFormSubmissionUuid,
};

export default DocumentService;
